import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ResidenceService } from './residence.abstract.service';
import { AdminCreateResidenceRequest, Residence, ResidenceSubType, ResidenceVerificationStatus, ReviewResidenceRequest } from '../residence.model';
import { Address } from '../../user/user.model';

@Injectable()
export class ResidenceServiceImpl extends ResidenceService {
    private baseUrl = `${environment.API_GATEWAY_URL}/profile/residence/admin`;

    constructor(private http: HttpClient) {
        super();
    }

    getPendingResidences(): Observable<Residence[]> {
        return this.http.get<Residence[]>(`${this.baseUrl}/pending`);
    }

    getAllResidences(status?: ResidenceVerificationStatus): Observable<Residence[]> {
        const params: Record<string, string> = {};
        if (status) {
            params.status = status;
        }
        return this.http.get<Residence[]>(`${this.baseUrl}/all`, { params });
    }

    getCitizenResidences(userId: string): Observable<Residence[]> {
        return this.http.get<Residence[]>(`${this.baseUrl}/user/${userId}`);
    }

    reviewResidence(id: string, dto: ReviewResidenceRequest): Observable<Residence> {
        return this.http.patch<Residence>(`${this.baseUrl}/${id}/verification`, dto);
    }

    createResidence(dto: AdminCreateResidenceRequest): Observable<Residence> {
        return this.http.post<Residence>(this.baseUrl, dto);
    }

    setAsPrimary(residenceId: string): Observable<Residence> {
        return this.http.patch<Residence>(`${this.baseUrl}/${residenceId}/primary`, {});
    }

    reviewRenewal(id: string, dto: ReviewResidenceRequest): Observable<Residence> {
        return this.http.patch<Residence>(`${this.baseUrl}/${id}/renewal`, dto);
    }

    updateResidenceName(id: string, name: string): Observable<Residence> {
        return this.http.patch<Residence>(`${environment.API_GATEWAY_URL}/profile/residence/${id}/name`, { name });
    }

    updateResidenceAddress(id: string, address: Address): Observable<Residence> {
        return this.http.patch<Residence>(`${this.baseUrl}/${id}/address`, { address });
    }

    updateResidenceSubType(id: string, subType: ResidenceSubType): Observable<Residence> {
        return this.http.patch<Residence>(`${this.baseUrl}/${id}/sub-type`, { subType });
    }
}

export const RESIDENCE_SERVICE_PROVIDER = {
    provide: ResidenceService,
    useClass: ResidenceServiceImpl,
};
